import Vue from "vue"

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */
const getters = {
    get: (state, getters, rootState) => rootState.appStore.application.loan_tiers
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */
const mutations = {

}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {

}

export default {
    namespaced: true,
    namespace: "application/loanTiers",
    modules: getModules('loanTiers'),
    state: {},
    getters,
    mutations,
    actions
}
